export enum PlayerProfileTab {
  PLAYTRACKER = 'playTracker',
  RANKINGS = 'rankings',
  SUSPENSIONS = 'suspensions',
  TOURNAMENTS = 'tournaments',
  DUAL_MATCHES = 'dualMatches',
}
